@if (user == undefined) {
  <p>Please Wait ....</p>
}

@if (user != undefined) {
  <div class="page-content">
    <div class=" ontario-padding-bottom-24-!">
      <h1 class="page-title">{{'RegistrationRedirect.MLITSDPreventionCMSRegistration' | translate}}</h1>
    </div>
    <div class="page-content-with-right-sidebar" style="margin-top: 0px !important;">
      <div class="main-content">
        <div class="ontario-column ontario-large-7 ontario-medium-6 ontario-small-12">
          <div class="ontario-margin-top-12-!"><b>{{'RegistrationRedirect.TrainingProviderPortal' | translate}}</b>
        </div>
        <div class="ontario-margin-top-12-!">{{'RegistrationRedirect.TrainingProviderPortalDescription' | translate}}
        </div>
        <button (click)="goRegisterAsTrainingProvider()" class="blue-button">{{'RegistrationRedirect.RegisterasTrainingProvider' | translate}}
        </button>
        <hr class="small"/>
        <div class="ontario-margin-top-24-!"><b>{{'RegistrationRedirect.EmployerPortal' | translate}}</b></div>
        <div class="ontario-margin-top-12-!">{{'RegistrationRedirect.EmployerPortalDescription' | translate}}</div>
        <button (click)="goRegisterAsEmployer()" class="blue-button">{{'RegistrationRedirect.RegisterasanEmployer' | translate}}
        </button>
        <hr class="small"/>
        <div class="ontario-margin-top-24-!"><b>{{'RegistrationRedirect.LearnerPortal' | translate}}</b></div>
        <div class="ontario-margin-top-12-!">{{'RegistrationRedirect.LearnerPortalDescription' | translate}}</div>
        <button (click)="goRegisterAsLearner()" class="blue-button">{{'RegistrationRedirect.RegisterAsALearner' | translate}}
        </button>
        <div class="ontario-margin-top-12-!"> &nbsp;
        </div>
      </div>
    </div>
    <div class="right-sidebar">
      <div class="title"><b> {{'RegistrationRedirect.Accessmultipleportalswithyouraccount' | translate }} </b></div>
      <div class="content">
        <p>{{'RegistrationRedirect.Ifyouusedthesameemail' | translate}}</p>
        <a target="_blank" [href]="'safety-and-prevention/faqs#account'">
          {{'RegistrationRedirect.Learnmoreaboutaccountsetupandlogin'| translate}}<img alt="external link"
          class="ext-link" src="assets/images/external-link-blue.svg">
        </a>
      </div>
    </div>
  </div>
</div>
}